<template>
    <letter-layout
        title="情不知其所起，一往而情深"
        date="2026年3月10日"
        sign-date="2026年3月10日"
        :paragraphs="paragraphs"
    />
</template>

<script>
import LetterLayout from './letterLayout.vue';

export default {
    components: { LetterLayout },
    data() {
        return {
            paragraphs: [
                '情不知其所起，一往而情深，有些人光是遇到，就已经是上上签了，如果爱上一个不能在一起的人请不要纠缠，不要伤害，不要跟他闹，一定要保持清醒，不管多么不舍，多么痛苦，多么思念，都不要把这份感情变成灾难，虽然他可能没有给你一个你想要的结果，但他至少曾照亮过你的内心，驱散过你的孤独，这对于我们来说就已经很幸运了，拥有过就好，要求的太多，只会让自己越来越痛苦，或许遗憾了，才是最好的，才能让人念念不忘。',
                '我很喜欢一句话：爱是当你望向我时，所有星光穿透我的心脏，而我赌你的枪里没有子弹，我希望我们都能赌赢。',
                '如果注定没有结果，放在心底生生世世牵挂见过花开就好啦，何必在意花落谁家，又何必在意花为谁而开，至少有一刻，闻到过花香，体验到了只为这一刻的浪漫。',
                '如果注定不能在一起，不能一辈子，那就做知己，用另一种方式相爱，相守。人海茫茫遇到不容易，所以相遇就要珍惜，好好珍惜每一次相处的时间，好好珍惜每一次的拥抱好好珍惜每一次的聊天，这些都会在你以后不开心时陪伴你，成为你最美好的回忆，既然不能在一起那就给彼此留个好印象吧，也许以后在他心里也永远有你的一席之位。',
                '如果注定做不了恋人，也做不了夫妻，那就以朋友之名相守，淡淡的喜欢，浅浅的爱，不近不远的看着，虽不能天长地久，但也是曾经拥有。',
                '很喜欢宫崎骏说过的一句话，我在很平常的一天放弃了一个很重要的人，虽然有点舍不得，但我满心欢喜，人世间得失取舍，又不是你一个爱而不得，生而为人，遗憾，是人生常态，失去，也是兵家常事，思而不语，念而不忘才是最好的结局…拿的起放得下是成年人的必修课，真诚过便无遗憾…',
                '离开并不代表不爱，放手并不代表释怀，而是明知道没有结果还要继续那就是再彼此伤害。不是每个人都能遇到一眼就喜欢上的人，所以遇到就好，爱过就够。',
                '真正爱一个人并不是你离开了我会哭，而是看着你幸福我仍会发自内心的会笑，不管你的幸福里有没有我，我都会送上我最真心的祝福。'
            ]
        };
    }
};
</script>
